<template>
  <vs-card class="mt-5" v-show="files.length">
    <div slot="header">
      <h3 class="text-center">
        Poprawność plików
      </h3>
      <p class="mt-2">{{message}}</p>
    </div>

    <vs-table :data="files">
      <template slot-scope="{data}">
        <vs-tr :state="color(data[indextr].state)" :key="indextr" v-for="(tr, indextr) in data">


          <vs-td :data="data[indextr].name">
            {{data[indextr].name}}
          </vs-td>

          <vs-td :data="data[indextr].state">
            {{t(data[indextr].state)}}
          </vs-td>

        </vs-tr>
      </template>
    </vs-table>

    <div slot="footer">
      <div class="mb-5" v-show="">
        <p></p>
      </div>
    </div>
  </vs-card>
</template>

<script>
  export default {
    name: "VerificationTable",
    props: {
      files: {
        type: Array,
        required: true
      }
    },
    methods: {
      color(state) {
        switch (state) {
          case 'removed':
            return 'danger';
          case 'pending':
            return 'primary';
          case 'queued':
            return 'success';
          default:
            return null;
        }
      },
      t(state) {
        switch (state) {
          case 'removed':
            return 'Nie poprawny';
          case 'pending':
            return 'Przetwarzany';
          case 'queued':
            return 'Przyjęty';
          default:
            return null;
        }
      }
    },
    computed: {
      message() {
        if(this.files.some(f => f.state === 'removed')) {
          return 'Wgraj zdjęcia lepszej jakości. Nie rozpoznano tekstu.';
        }
        if(this.files.every(f => f.state === 'queued')) {
          return 'Twoje pliki zostały zostały przyjęte. Możesz przejść dalej.';
        }
        return 'Poczekaj aż wszystkie pliki zostaną zweryfikowane.';
      }
    }
  }
</script>

<style scoped>

</style>
